import { useMediaQuery } from 'react-responsive';
import theme from '../../../../components/ui-kit/themes/theme';
import CloseIcon from '../../../ui-kit/icons/Close';
import { ModalContent } from './ModalContent';
import { CloseButtonContainer, Divider, Header, ModalWrapper, Title } from './styles';

export const SummaryModal = ({ opened, children, ...restProps }) => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.sm})`
  });

  return (
    <ModalWrapper
      isOpen={opened}
      padding={0}
      {...restProps}
      borderRadius={isMobile ? '25px 25px 0 0' : '25px'}
      width={isMobile ? '100%' : '466px'}
      opensFromBottom>
      {children}
    </ModalWrapper>
  );
};

SummaryModal.CloseButton = ({ onClick, isMobile }) => {
  return (
    <CloseButtonContainer onClick={onClick}>
      <CloseIcon color={theme.colors.preciousStoneBlue[100]} size={['14px', '16px']} />
    </CloseButtonContainer>
  );
};

SummaryModal.Content = ModalContent;

SummaryModal.Divider = () => {
  return <Divider />;
};

SummaryModal.Header = ({ children, ...restProps }) => {
  return <Header {...restProps}>{children}</Header>;
};

SummaryModal.Title = ({ children, ...restProps }) => {
  return <Title {...restProps}>{children}</Title>;
};
